import React, { FC, RefObject, useEffect, useRef, useState } from 'react'
import {
	RadioList,
	RequestFormProps,
	RequestInputs,
	SelectList
} from '@utils/request'
import requestForm from '@components/requestForms/request.form'
import SelectInput from '@components/requestForms/inputs/select.inputs'
import { REQUEST_CONFIGS_KEYS } from '@services/constants'
import TextInput from './inputs/text.inputs'
import RadioInput from './inputs/radio.input'

const SpeedAndSignalingForm: FC<RequestFormProps> = ({
	inputs,
	errors,
	onInputsChange,
	onFixError
}) => {
	const {
		pageAssets,
		UpdateRequestInputsArray,
		UpdateRequestInputsErrorsArray,
		displayWarningSection
	} = requestForm()

	// À quel moment de la journée et de la semaine les événements se produisent.
	const [timeOfEvents, setTimeOfEvents] = useState<RequestInputs>({
		name: 'timeOfEvents',
		value: '',
		valueKey: '',
		label: pageAssets?.request_form_speedAndSignaling_timeOfEvents_label,
		labelKey: 'request_form_speedAndSignaling_timeOfEvents_label',
		required: true,
		ref: useRef<HTMLSelectElement>(null),
		isSentInDetails: true
	})

	// Êtes-vous en mesure d'identifier le contrevenant ?
	const [canIdentifyOffender, setCanIdentifyOffender] = useState<RequestInputs>(
		{
			name: 'canIdentifyOffender',
			value: '',
			valueKey: '',
			label:
				pageAssets?.request_form_speedAndSignaling_canIdentifyOffender_label,
			labelKey: 'request_form_speedAndSignaling_canIdentifyOffender_label',
			required: true,
			ref: useRef<HTMLSelectElement>(null)
		}
	)

	// Quels sont les éléments qui vous permettre de détailler le contrevenant (adresse, modèle de voiture, plaque d'immatriculation, etc.)
	const [offenderDetails, setOffenderDetails] = useState<RequestInputs>({
		name: 'offenderDetails',
		value: '',
		valueKey: '',
		label: pageAssets?.request_form_speedAndSignaling_offenderDetails_label,
		labelKey: 'request_form_speedAndSignaling_offenderDetails_label',
		required: false,
		ref: useRef<HTMLSelectElement>(null),
		isSentInDetails: true
	})

	const RadioYesNoList: RadioList[] = [
		{
			label: pageAssets?.request_form_select_yes,
			value: REQUEST_CONFIGS_KEYS.yes,
			key: 'request_form_select_yes'
		},
		{
			label: pageAssets?.request_form_select_no,
			value: REQUEST_CONFIGS_KEYS.no,
			key: 'request_form_select_no'
		}
	]

	const onChangeTimeOfEvents = (value: string, valueKey: string) => {
		setTimeOfEvents({ ...timeOfEvents, value, valueKey })
		onFixError(UpdateRequestInputsErrorsArray(errors, timeOfEvents.name))
	}

	const onChangeCanIdentifyOffender = (value: string, valueKey: string) => {
		setCanIdentifyOffender({ ...canIdentifyOffender, value, valueKey })
		if (value == REQUEST_CONFIGS_KEYS.yes) {
			setOffenderDetails({
				...offenderDetails,
				required: true
			})
		} else {
			setOffenderDetails({
				...offenderDetails,
				value: '',
				valueKey: '',
				required: false
			})
		}

		onFixError(
			errors.filter(
				(error) =>
					![canIdentifyOffender.name, offenderDetails.name].includes(error)
			)
		)
	}

	const onChangeOffenderDetails = (value: string, valueKey: string) => {
		setOffenderDetails({ ...offenderDetails, value, valueKey })
		onFixError(UpdateRequestInputsErrorsArray(errors, offenderDetails.name))
	}

	useEffect(() => {
		onInputsChange(UpdateRequestInputsArray(inputs, timeOfEvents))
	}, [timeOfEvents])

	useEffect(() => {
		onInputsChange(UpdateRequestInputsArray(inputs, canIdentifyOffender))
	}, [canIdentifyOffender])

	useEffect(() => {
		onInputsChange(UpdateRequestInputsArray(inputs, offenderDetails))
	}, [offenderDetails])

	return (
		<>
			{/* <SelectInput
				id={intervantionType.name}
				label={intervantionType.label}
				list={interventionTypeList}
				value={intervantionType.value}
				required
				onChange={onChangeIntervantionType}
				hasError={errors.includes(intervantionType.name)}
				ref={intervantionType.ref as RefObject<HTMLSelectElement>}
			/>

			{intervantionType.value === REQUEST_CONFIGS_KEYS.intervention.police &&
				displayWarningSection(
					pageAssets?.request_form_speed_signaling_info_text_surveillance_label
				)}

			{intervantionType.value === REQUEST_CONFIGS_KEYS.intervention.signage &&
				displayWarningSection(
					pageAssets?.request_form_speed_signaling_info_text_modification_label
				)} */}

			<TextInput
				id={timeOfEvents.name}
				label={timeOfEvents.label}
				value={timeOfEvents.value}
				onChange={onChangeTimeOfEvents}
				hasError={errors.includes(timeOfEvents.name)}
				required={timeOfEvents.required}
				ref={timeOfEvents.ref as RefObject<HTMLInputElement>}
			/>

			<RadioInput
				name={canIdentifyOffender.name}
				label={canIdentifyOffender.label}
				value={canIdentifyOffender.value}
				onChange={onChangeCanIdentifyOffender}
				hasError={errors.includes(canIdentifyOffender.name)}
				required={canIdentifyOffender.required}
				list={RadioYesNoList}
				ref={canIdentifyOffender.ref as RefObject<HTMLInputElement>}
			/>

			{canIdentifyOffender.value == REQUEST_CONFIGS_KEYS.yes && (
				<TextInput
					id={offenderDetails.name}
					label={offenderDetails.label}
					value={offenderDetails.value}
					onChange={onChangeOffenderDetails}
					hasError={errors.includes(offenderDetails.name)}
					required={offenderDetails.required}
					ref={offenderDetails.ref as RefObject<HTMLInputElement>}
				/>
			)}
		</>
	)
}

export default SpeedAndSignalingForm
